import {
    CartOrderSubmitParams,
    CartOrderSubmitResponse,
    GenerateCartPdfResponse,
    GetPdfFromHtmlParams,
    GetPdfFromHtmlResponse,
} from 'api/dataTypes';
import {AxiosError} from 'axios';

import {BaseApi} from './BaseApi';

export class GlobalApi extends BaseApi {
    constructor() {
        super({baseURL: 'https://www.klenmarket.ru'});
        this.setup();
    }

    private setup = () => {
        this.httpClient.interceptors.response.use(
            function (response) {
                return response.data;
            },
            function (error: AxiosError) {
                return Promise.reject(error.response?.data || error);
            },
        );
    };

    generateCartPdf = (): Promise<GenerateCartPdfResponse> => {
        return this.httpClient.get('/shop/cart/?download', {
            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest',
            },
        });
    };

    getPdfFromHtml = (
        params: GetPdfFromHtmlParams,
    ): Promise<GetPdfFromHtmlResponse> => {
        return this.httpClient.get('/pdf_external_service.php', {
            params: {
                path_to_html: params.path_to_html,
            },
        });
    };

    cartOrderSubmit = (
        params: CartOrderSubmitParams,
    ): Promise<CartOrderSubmitResponse> => {
        return this.httpClient.post('/shop/cart/?no_redirect=true', params, {
            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded; charset=UTF-8',
            },
        });
    };
}
